import { Dialog, Transition } from "@headlessui/react";
import { IconX, IconPrinter } from "@tabler/icons-react";
import { useState, useRef, Fragment } from "react";
import { useReactToPrint } from "react-to-print";
import { imageBaseUrl } from "../../config/http";
import PrintSuratTrxPenjualan from "./PrintSuratTrxPenjualan";
import TestingPrint from "./TestingPrint";
import SuratKeruak from "./SuratKeruak";
import SuratToko from "../../components/surat/SuratToko";

export default function DetailBarangPenjualan({ closeModal, label, detailPenjualan, isOpen, isTertunda }) {
  function numberWithCommas(x) {
    if (x === null || x === undefined || x === "") return "0";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function roundBerat(number) {
    if (number === null || number === undefined || number === "") return "0.000";
    const num = Number(number);
    return isNaN(num) ? "0.000" : num.toFixed(3);
  }

  const [openImage, setOpenImage] = useState(false);
  const compSurat = useRef();

  const handlePrint = useReactToPrint({
    content: () => compSurat.current,
    documentTitle: detailPenjualan?.kode_trx ? `Struk_${detailPenjualan.kode_trx}` : "Struk_Penjualan",
  });

  const beratItem = Number(detailPenjualan?.item?.berat) || 0;
  const harga_modal_jual = beratItem > 0 ? (Number(detailPenjualan?.total_harga) || 0) / beratItem : 0;
  const tipe_surat = localStorage.getItem("tipe_surat");

  const totalHargaTrx = Number(detailPenjualan?.total_harga) || 0;

  // Normalisasi data pembayaran
  const rawPayments = detailPenjualan?.payments && Array.isArray(detailPenjualan.payments) && detailPenjualan.payments.length > 0
    ? detailPenjualan.payments
    : detailPenjualan?.metode_pembayaran
      ? [{ metode_pembayaran: detailPenjualan.metode_pembayaran, nama_bank: detailPenjualan.nama_bank || "", nominal: totalHargaTrx }]
      : [{ metode_pembayaran: "cash", nama_bank: "", nominal: totalHargaTrx }];

  const isSplit = rawPayments.filter((p) => (Number(p.nominal) || 0) > 0).length > 1;

  const formatTglItem = (dateStr) => {
    if (!dateStr) return "-";
    try {
      if (dateStr.includes("-")) {
        const parts = dateStr.split(" ")[0].split("-");
        if (parts.length === 3) {
          if (parts[0].length === 4) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
          }
          return `${parts[0]}/${parts[1]}/${parts[2]}`;
        }
      }
      return String(dateStr).split(" ")[0];
    } catch {
      return dateStr;
    }
  };

  const formatTglTrx = (dateStr) => {
    if (!dateStr) return "-";
    try {
      if (dateStr.includes("-")) {
        const [dPart, tPart] = dateStr.split(" ");
        const parts = dPart.split("-");
        if (parts.length === 3 && parts[0].length === 4) {
          return `${parts[2]}/${parts[1]}/${parts[0]}${tPart ? ` ${tPart}` : ""}`;
        }
      }
      return dateStr;
    } catch {
      return dateStr;
    }
  };

  const getImageUrl = () => {
    const g = detailPenjualan?.item?.gambar1;
    if (!g) return null;
    if (Array.isArray(g)) {
      if (g.length === 0) return null;
      if (typeof g[0] === "object" && g[0] !== null) {
        return g[0].asli ? `${imageBaseUrl}${g[0].asli}` : null;
      }
      return `${imageBaseUrl}${g[0]}`;
    }
    if (typeof g === "string") {
      try {
        const parsed = JSON.parse(g);
        if (Array.isArray(parsed) && parsed.length > 0) {
          if (typeof parsed[0] === "object" && parsed[0] !== null) {
            return `${imageBaseUrl}${parsed[0].asli || parsed[0]}`;
          }
          return `${imageBaseUrl}${parsed[0]}`;
        }
      } catch {
        return `${imageBaseUrl}${g}`;
      }
    }
    return null;
  };
  const imgSrc = getImageUrl();

  return (
    <>
      {/* Lightbox Pratinjau Foto Barang (Headless UI Dialog Mandiri) */}
      <Transition appear show={openImage && Boolean(imgSrc)} as={Fragment}>
        <Dialog as="div" className="relative z-[130]" onClose={() => setOpenImage(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/85 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative max-w-[90vw] max-h-[85vh] p-1 bg-slate-900/90 rounded-2xl shadow-2xl border border-slate-700/80 flex items-center justify-center">
                  <button
                    type="button"
                    onClick={() => setOpenImage(false)}
                    className="absolute -top-3 -right-3 p-2 bg-slate-800 hover:bg-slate-700 text-white rounded-full transition shadow-xl z-20 cursor-pointer border border-slate-600"
                    title="Tutup Pratinjau Foto"
                  >
                    <IconX size={20} />
                  </button>
                  {imgSrc && (
                    <img
                      src={imgSrc}
                      alt="Foto Barang"
                      className="max-w-[85vw] max-h-[80vh] object-contain rounded-xl"
                    />
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Modal Utama Detail Penjualan */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[90]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/40 dark:bg-slate-950/80 backdrop-blur-sm" />
          </Transition.Child>

          {/* Hidden Print Components - Selalu ada di DOM untuk memastikan Cetak Struk selalu siap */}
          <div
            ref={compSurat}
            className="invisible print:visible absolute bg-white print:h-screen print:w-full"
          >
            {tipe_surat === "2" ? (
              <TestingPrint isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            ) : tipe_surat === "3" ? (
              <SuratKeruak isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            ) : tipe_surat === "4" ? (
              <SuratToko isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            ) : (
              <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={detailPenjualan} isTertunda={isTertunda} />
            )}
          </div>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 sm:p-6 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xl sm:max-w-2xl transform overflow-hidden rounded-2xl bg-white dark:bg-[#0e1628] border border-slate-200 dark:border-slate-800/90 p-5 sm:p-6 text-left align-middle shadow-2xl transition-all">
                  {/* Header */}
                  <div className="flex items-start justify-between pb-2">
                    <div>
                      <Dialog.Title as="h2" className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white tracking-tight">
                        {label || "Penjualan"}
                      </Dialog.Title>
                      <div className="flex flex-wrap items-center gap-2 mt-1 text-sm">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Kode Faktur :</span>
                        <span className="font-bold text-amber-600 dark:text-amber-400">
                          {detailPenjualan?.kode_trx || "-"}
                        </span>
                        <span className="text-slate-300 dark:text-slate-700 mx-1">|</span>
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Tanggal :</span>
                        <span className="text-slate-800 dark:text-slate-200 font-semibold">
                          {formatTglTrx(detailPenjualan?.created_at || detailPenjualan?.tanggal)}
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={closeModal}
                      className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800/60 transition cursor-pointer"
                      title="Tutup"
                    >
                      <IconX size={20} />
                    </button>
                  </div>

                  {/* Card Detail Transaksi */}
                  <div className="mt-2 bg-white dark:bg-[#131b2e] border border-slate-200 dark:border-slate-800/80 rounded-xl overflow-hidden divide-y divide-slate-100 dark:divide-slate-800/70 shadow-sm">
                    <div className="px-4 py-2 sm:py-2.5 bg-slate-50/70 dark:bg-[#172136]">
                      <h3 className="text-amber-700 dark:text-amber-400 font-bold text-sm tracking-wide">
                        Detail Transaksi
                      </h3>
                    </div>

                    {/* Row 1: Item */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <span className="text-slate-600 dark:text-slate-400 font-medium whitespace-nowrap">Item</span>
                      <div className="text-right flex flex-wrap items-center justify-end gap-2">
                        <span className="px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800/90 text-slate-600 dark:text-slate-400 text-xs border border-slate-200 dark:border-slate-700">
                          {formatTglItem(detailPenjualan?.item?.created_at)}
                        </span>
                        <span className="font-semibold text-slate-900 dark:text-slate-100">
                          {detailPenjualan?.item?.kode_item} - {detailPenjualan?.item?.jenis_kategori?.nama_jenis || detailPenjualan?.jenis_kategori?.nama_jenis || "-"}
                        </span>
                      </div>
                    </div>

                    {/* Row 2: Berat */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <span className="text-slate-600 dark:text-slate-400 font-medium">Berat</span>
                      <span className="font-semibold text-slate-900 dark:text-slate-100">
                        {roundBerat(detailPenjualan?.item?.berat)} Gram
                      </span>
                    </div>

                    {/* Row 3: Emas */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <span className="text-slate-600 dark:text-slate-400 font-medium">Emas</span>
                      <span className="font-semibold text-slate-900 dark:text-slate-100">
                        {detailPenjualan?.item?.karat || 0} Karat
                      </span>
                    </div>

                    {/* Row 4: Harga Modal / gram */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <div>
                        <span className="text-slate-600 dark:text-slate-400 font-medium block">Harga Modal / gram</span>
                        <span className="text-slate-400 dark:text-slate-500 text-xs italic block mt-0.5">(* Harga modal saat diinput)</span>
                      </div>
                      <span className="font-semibold text-slate-900 dark:text-slate-100">
                        Rp {numberWithCommas(detailPenjualan?.item?.harga_modal ?? 0)}
                      </span>
                    </div>

                    {/* Row 5: Harga Jual / gram */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <div>
                        <span className="text-slate-600 dark:text-slate-400 font-medium block">Harga Jual / gram</span>
                        <span className="text-slate-400 dark:text-slate-500 text-xs italic block mt-0.5">(* Total harga jual dibagi berat)</span>
                      </div>
                      <span className="font-semibold text-slate-900 dark:text-slate-100">
                        Rp {numberWithCommas(Math.round(harga_modal_jual || 0))}
                      </span>
                    </div>

                    {/* Row 6: Total Harga */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 bg-amber-50/40 dark:bg-amber-950/20">
                      <span className="text-slate-700 dark:text-slate-200 font-bold text-sm">Total Harga</span>
                      <span className="text-amber-600 dark:text-amber-400 font-bold text-sm">
                        Rp {numberWithCommas(detailPenjualan?.total_harga ?? 0)}
                      </span>
                    </div>

                    {/* Rincian Metode Pembayaran */}
                    <div className="px-4 py-1.5 sm:py-2 text-sm border-t border-slate-100 dark:border-slate-800/80">
                      <div className="flex items-center justify-between mb-1.5">
                        <span className="text-slate-600 dark:text-slate-400 font-medium">
                          Metode Pembayaran
                        </span>
                        {isSplit ? (
                          <span className="text-amber-700 dark:text-amber-400 font-semibold text-xs px-2.5 py-0.5 rounded-full bg-amber-100 dark:bg-amber-500/20 border border-amber-300 dark:border-amber-500/30">
                            Split Bayar ({rawPayments.filter((p) => Number(p.nominal) > 0).length} Metode)
                          </span>
                        ) : (
                          <span className="text-emerald-700 dark:text-emerald-400 font-semibold text-xs px-2.5 py-0.5 rounded-full bg-emerald-100 dark:bg-emerald-500/20 border border-emerald-300 dark:border-emerald-500/30">
                            100% Lunas
                          </span>
                        )}
                      </div>
                      <div className="space-y-1.5 pt-0.5">
                        {rawPayments.map((p, idx) => (
                          <div key={idx} className="flex justify-between items-center text-sm">
                            <span className="text-slate-700 dark:text-slate-300 font-medium flex items-center gap-2">
                              <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
                              {p.metode_pembayaran === "edc" ? "Debit / EDC" : (p.metode_pembayaran?.toUpperCase() || "CASH")} {p.nama_bank ? `(${p.nama_bank})` : ""}
                            </span>
                            <span className="font-semibold text-slate-900 dark:text-slate-100">
                              Rp {numberWithCommas(p.nominal)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Row 7: Laba Penjualan */}
                    <div className="px-4 py-1.5 sm:py-2 flex items-center justify-between gap-3 text-sm">
                      <div>
                        <span className="text-slate-600 dark:text-slate-400 font-medium block">Laba Penjualan</span>
                        <span className="text-slate-400 dark:text-slate-500 text-xs italic block mt-0.5">(* Jika minus = RUGI, jika plus = UNTUNG)</span>
                      </div>
                      <span
                        className={`font-semibold text-sm ${(detailPenjualan?.laba ?? 0) >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}
                      >
                        Rp {numberWithCommas(Math.round(detailPenjualan?.laba ?? 0))}
                      </span>
                    </div>
                  </div>

                  {/* Section Gambar */}
                  <div className="mt-2.5">
                    <h4 className="text-slate-800 dark:text-white font-bold text-sm mb-1.5">Gambar</h4>
                    <div className="w-20 h-20 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-slate-100 dark:bg-slate-900/60 p-1 flex items-center justify-center shadow-inner">
                      {imgSrc ? (
                        <img
                          src={imgSrc}
                          onClick={() => setOpenImage(true)}
                          alt="Foto barang"
                          className="w-full h-full object-cover rounded-lg hover:scale-105 transition cursor-pointer"
                        />
                      ) : (
                        <span className="text-xs text-slate-400 dark:text-slate-500">Tidak ada gambar</span>
                      )}
                    </div>
                  </div>

                  {/* Footer Actions */}
                  <div className="mt-4 flex items-center justify-end gap-3">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="px-5 py-2.5 bg-slate-100 hover:bg-slate-200 dark:bg-[#1b263b] dark:hover:bg-[#22304a] active:bg-slate-300 dark:active:bg-[#151e2e] text-slate-700 dark:text-slate-200 font-semibold text-sm rounded-xl border border-slate-300 dark:border-slate-700/80 transition cursor-pointer"
                    >
                      Tutup
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (compSurat.current) {
                          handlePrint();
                        }
                      }}
                      className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 text-white font-bold text-sm rounded-xl shadow-lg shadow-amber-500/20 transition cursor-pointer flex items-center gap-2"
                    >
                      <IconPrinter size={18} stroke={2.2} />
                      <span>Cetak Struk</span>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
